import { COUNTRIES, type Country } from './countries';
import { localizedCountry } from './country-names';

export type PhoneCountryOption = Country & { localizedName: string };

export function getPhoneCountryOptions(language: string, search = ''): PhoneCountryOption[] {
  const query = search.trim();
  const localizedQuery = query.toLocaleLowerCase(language);
  const fallbackQuery = query.toLowerCase();

  return COUNTRIES.map((country) => ({
    ...country,
    localizedName: localizedCountry(country.iso, country.name, language),
  })).filter((country) => !query
    || country.localizedName.toLocaleLowerCase(language).includes(localizedQuery)
    || country.name.toLowerCase().includes(fallbackQuery)
    || country.dial.includes(fallbackQuery)
    || country.iso.toLowerCase().includes(fallbackQuery));
}
